import { render, staticRenderFns } from "./ServiceFormDetail.vue?vue&type=template&id=00fc4fcc&"
import script from "./ServiceFormDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormDetail.vue?vue&type=style&index=0&id=00fc4fcc&prod&lang=css&"
import style1 from "./ServiceFormDetail.vue?vue&type=style&index=1&id=00fc4fcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports